console.log('Version: 1.3.8')
window.pathname = `/pages/diamond-search`
window.__evosem_ssurl = 'https://diamonds-app.evosem.com';
window.currentCurrencySymbol = '$';
window.__evosemMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec' ];
window.diamondsLabs = [ 'GCAL', 'GIA', 'GSI', 'HRD', 'IGI','NONE'];
window.diamondsClarity = [ {label: "I2", value: "I2"}, {label: "I1", value: "I1"}, {label: "SI3", value: "SI3"}, {label: "SI2", value: "SI2"}, {label: "SI1", value: "SI1"}, {label: "VS2", value: "VS2"}, {label: "VS1", value: "VS1"}, {label: "VVS2", value: "VVS2"}, {label: "VVS1", value: "VVS1"}, {label: "IF", value: "IF"}, {label: "FL", value: "FL"} ]
window.diamondsColours = [ {label:"N", value:"N"}, {label:"M", value:"M"}, {label:"L", value:"L"}, {label:"K", value:"K"}, {label:"J", value:"J"}, {label:"I", value:"I"}, {label:"H", value:"H"}, {label:"G", value:"G"}, {label:"F", value:"F"}, {label:"E", value:"E"}, {label:"D", value:"D"} ]
window.diamondsCut = [{ label: 'none', value: 'NONE', }, { label: 'fair', value: 'F', },{ label: 'good', value: 'G', },{ label: 'very good', value: 'VG', },{ label: 'excellent', value: 'EX', },{ label: 'ideal', value: 'ID', }];
window.diamondsPolish = [{ label: 'none', value: 'NONE', },{ label: 'fair', value: 'F', },{ label: 'good', value: 'G', },{ label: 'very good', value: 'VG', },{ label: 'excellent', value: 'EX', },{ label: 'ideal', value: 'ID', }];
window.diamondsSymmetry = [{ label: 'none', value: 'NONE', },{ label: 'fair', value: 'F', },{ label: 'good', value: 'G', },{ label: 'very good', value: 'VG', },{ label: 'excellent', value: 'EX', },{ label: 'ideal', value: 'ID', }];
window.diamondsShapes = [{ label: 'round', value: 'RD', },{ label: 'oval', value: 'OV', },{ label: 'cushion', value: 'CU', },{ label: 'princess', value: 'PR', },{ label: 'emerald', value: 'EM', },{ label: 'pear', value: 'PS', },{ label: 'marquise', value: 'MQ', },{ label: 'asscher', value: 'AS', },{ label: 'radiant', value: 'RT', },{ label: 'heart', value: 'HRT', }];
window.diamondsFancyColorsIntensity= [{ label: 'Light', value: 'L', },{ label: 'Fancy Light', value: 'FL', },{ label: 'Fancy', value: 'FC', },{ label: 'Fancy Intense', value: 'I', },{ label: 'Fancy Vivid', value: 'FV', },{ label: 'Fancy Deep', value: 'D', }];
window.diamondsFancyColors = [ { label: "Black", value: "BK" }, { label: "Blue", value: "B" }, { label: "Pink", value: "P" }, { label: "Purple", value: "PL" }, { label: "Yellow", value: "Y" }, { label: "Green", value: "G" }, ];
window.diamondsFluorescence = [{ label: 'none', value: 'NONE', },{ label: 'Faint', value: 'F', },{ label: 'Medium', value: 'M', },{ label: 'Strong', value: 'S', },{ label: 'Very Strong', value: 'VS', }];
window.__shapes = [{ label: 'round', value: 'RD', },{ label: 'princess', value: 'PR', },{ label: 'emerald', value: 'EM', },{ label: 'asscher', value: 'AS', },{ label: 'marquise', value: 'MQ', },{ label: 'oval', value: 'OV', },{ label: 'square radiant', value: 'SQRT', },{ label: 'radiant', value: 'RT', },{ label: 'pear', value: 'PS', },{ label: 'heart', value: 'HRT', },{ label: 'cushion', value: 'CU', },{ label: 'triangle', value: 'TA', },{ label: 'trilliant', value: 'TR', }];
window.__Labs = [ 'GCAL', 'GIA', 'GSI', 'HRD', 'IGI','NONE'];
window.__Clarity = [ {label: "I2", value: "I2"}, {label: "I1", value: "I1"}, {label: "SI3", value: "SI3"}, {label: "SI2", value: "SI2"}, {label: "SI1", value: "SI1"}, {label: "VS2", value: "VS2"}, {label: "VS1", value: "VS1"}, {label: "VVS2", value: "VVS2"}, {label: "VVS1", value: "VVS1"}, {label: "IF", value: "IF"}, {label: "FL", value: "FL"} ]
window.__Colours = [ {label:"N", value:"N"}, {label:"M", value:"M"}, {label:"L", value:"L"}, {label:"K", value:"K"}, {label:"J", value:"J"}, {label:"I", value:"I"}, {label:"H", value:"H"}, {label:"G", value:"G"}, {label:"F", value:"F"}, {label:"E", value:"E"}, {label:"D", value:"D"} ]
window.__Cut = [{ label: 'none', value: 'NONE', }, { label: 'fair', value: 'F', },{ label: 'good', value: 'G', },{ label: 'very good', value: 'VG', },{ label: 'excellent', value: 'EX', },{ label: 'ideal', value: 'ID', }];
window.__Polish = [{ label: 'none', value: 'NONE', },{ label: 'fair', value: 'F', },{ label: 'good', value: 'G', },{ label: 'very good', value: 'VG', },{ label: 'excellent', value: 'EX', },{ label: 'ideal', value: 'ID', }];
window.__Symmetry = [{ label: 'none', value: 'NONE', },{ label: 'fair', value: 'F', },{ label: 'good', value: 'G', },{ label: 'very good', value: 'VG', },{ label: 'excellent', value: 'EX', },{ label: 'ideal', value: 'ID', }];
window.__FancyColorsIntensity= [{ label: 'Light', value: 'L', },{ label: 'Fancy Light', value: 'FL', },{ label: 'Fancy', value: 'FC', },{ label: 'Fancy Intense', value: 'I', },{ label: 'Fancy Vivid', value: 'FV', },{ label: 'Fancy Deep', value: 'D', }];
window.__FancyColors = [ { label: "Black", value: "BK" }, { label: "Blue", value: "B" }, { label: "Pink", value: "P" }, { label: "Purple", value: "PL" }, { label: "Yellow", value: "Y" }, { label: "Green", value: "G" }, ];
window.__Fluorescence = [{ label: 'none', value: 'NONE', },{ label: 'Faint', value: 'F', },{ label: 'Medium', value: 'M', },{ label: 'Strong', value: 'S', },{ label: 'Very Strong', value: 'VS', }];



window.defaultlabgrownlab = []
window.defaultnaturallab = []
window.fixedNaturalCaratMin = null;
window.fixedNaturalCaratMax = null;
window.fixedLabCaratMin = null;
window.fixedLabCaratMax = null;
window.fixedNaturalCaratMin = null;
window.fixedNaturalCaratMax = null;
window.islabgrowndisabled = false;
window.isnaturaldisabled = false;
window.isnewtab = false;


window.__price = { min: 10, max: 3000000, };
window.__carat = { min: 0.08, max: 8.75, };

window.revertcolor = false;
window.revertclarity = false;
window.revertcut = false;
window.revertpolish = false;
window.revertsymmetry = false;


const __formatPrice = (price) => {
	try {
		if(price <= 0) return 'Call for price';
		return wNumb({ thousand: ',', mark: '.', decimals: 2, prefix: currentCurrencySymbol }).to(price)
	} catch ( error ) {
		return null
	}
}

var initSliders =  () => {      
	
	const diamondSearchSliderCall = args => {

		try {
			let subLabelsElement = null
			const parent = document.getElementById(args.id);
			if(!parent) return;

			//Create the needed basic elements.
			const filterInnerElement = document.createElement('div')
			filterInnerElement.classList.add('filter-inner')
			
			const slider = document.createElement('div')
			slider.classList.add('slider-handle')
			
			const sliderStepsLabelsElement = document.createElement('div')
			sliderStepsLabelsElement.classList.add('steps-labels')

			const filterLabelElement = document.createElement('div')
			filterLabelElement.classList.add('filter-label')
			
			parent.appendChild(filterLabelElement)
			parent.appendChild(filterInnerElement)
			filterInnerElement.appendChild(slider)
			filterInnerElement.appendChild(sliderStepsLabelsElement)


			const options = {}

			options.range = args.range

			options.start = [args.start[0],args.start[1]]
			options.connect = true
			if(args.margin) options.margin = args.margin
			if(args.step) options.step = args.step
			if(args.tooltips) options.tooltips = args.tooltips
			noUiSlider.create(slider, options)

			if(args.onStart && typeof args.onStart === 'function') slider.noUiSlider.on('start', args.onStart)
			if(args.onChange && typeof args.onChange === 'function') slider.noUiSlider.on('change', args.onChange)
			if(args.onUpdate && typeof args.onUpdate === 'function') slider.noUiSlider.on('update', args.onUpdate)
			if(args.onEnd && typeof args.onEnd === 'function') slider.noUiSlider.on('end', args.onEnd)

			if(args.isAdvanced) {
				parent.setAttribute('is-advanced', true)
			}

			if(args.title) {
				const title = document.createElement('strong')
				title.classList.add('text','uppercase')
				title.innerText = args.title
				filterLabelElement.appendChild(title)
			}

			if(args.leftSublabel || args.rightSublabel) {
				subLabelsElement = document.createElement('div')
				subLabelsElement.classList.add('filter-sub-label')
				filterLabelElement.appendChild(subLabelsElement)
			}

			if(args.leftSublabel) {
				const leftSublabelElement = document.createElement('div')
				leftSublabelElement.innerText = !args.isRevert ? args.leftSublabel : args.rightSublabel
				subLabelsElement.appendChild(leftSublabelElement)
			}

			if(args.rightSublabel) {
				const rightSublabelElement = document.createElement('div')
				rightSublabelElement.innerText = !args.isRevert ? args.rightSublabel : args.leftSublabel
				subLabelsElement.appendChild(rightSublabelElement)
			}

			if(args.labels) {
				const stepsList = document.createElement('ul')
				args.labels.map( item => {
					const listItem = document.createElement('li')
					listItem.innerText = item.label
					listItem.style.width = `${(100/args.labels.length)}%`

					const separation = document.createElement('span');
					separation.classList.add('separation');
					listItem.classList.add('uppercase')
					listItem.appendChild(separation);
					return stepsList.appendChild(listItem);
				})
				sliderStepsLabelsElement.appendChild(stepsList)
			}

			if(args.showInput) {
				const inputFieldsWrapper = document.createElement('div'),
				minFieldWrapper = document.createElement('div'),
				minFieldLabel = document.createElement('label'),
				minFieldLabelText = document.createElement('div'),
				minFieldInput = document.createElement('input'),
				maxFieldWrapper = document.createElement('div'),
				maxFieldLabel = document.createElement('label'),
				maxFieldLabelText = document.createElement('div'),
				maxFieldInput = document.createElement('input')

				if( _.isFunction(args.onInputChangeMin) ) minFieldInput.addEventListener('change', args.onInputChangeMin)
				if( _.isFunction(args.onInputChangeMax) ) maxFieldInput.addEventListener('change', args.onInputChangeMax)

				inputFieldsWrapper.classList.add('filter-input-fields')
				filterInnerElement.appendChild(inputFieldsWrapper)
				inputFieldsWrapper.appendChild(minFieldWrapper)
				inputFieldsWrapper.appendChild(maxFieldWrapper)
				minFieldWrapper.classList.add('filter-field')
				minFieldLabelText.classList.add('label-text')
				if(!args.short_field_title) minFieldLabelText.innerText = `Min ${args.title}`
				if(args.short_field_title) minFieldLabelText.innerText = `Min`
				minFieldWrapper.appendChild(minFieldLabel)
				minFieldLabel.appendChild(minFieldLabelText)
				minFieldLabel.appendChild(minFieldInput)
				minFieldInput.type = 'text'
				minFieldInput.name = `min-${args.id}`
				minFieldInput.id = `min-${args.id}`


				maxFieldWrapper.classList.add('filter-field')
				maxFieldLabelText.classList.add('label-text')
				if(!args.short_field_title) maxFieldLabelText.innerText = `Max ${args.title}`
				if(args.short_field_title) maxFieldLabelText.innerText = `Max`
				maxFieldWrapper.appendChild(maxFieldLabel)
				maxFieldLabel.appendChild(maxFieldLabelText)
				maxFieldLabel.appendChild(maxFieldInput)
				maxFieldInput.type = 'text'
				maxFieldInput.name = `max-${args.id}`
				maxFieldInput.id = `max-${args.id}`


				slider.noUiSlider.on('update', values =>{
					minFieldInput.value = args?.tooltips[0] ? args.tooltips[0].to(parseFloat(values[0])) : values[0]
					maxFieldInput.value = args?.tooltips[0] ? args.tooltips[0].to(parseFloat(values[1])) : values[1]
				})
				
			}

			return slider;


		} catch (error) {
			console.error(error)
		}
	}

	window.caratSlider = diamondSearchSliderCall({
		id: 'carat-slider',
		title: 'Carat',
		range: {
			min:window.__carat.min,
			max:window.__carat.max,
		},
		start:[window.__carat.min, window.__carat.max],
		tooltips: [
			wNumb({ thousand: ',', decimals: 2, suffix: 'ct' }), 
			wNumb({ thousand: ',', decimals: 2, suffix: 'ct' }),
		],
		showInput: true,
		onEnd: values => {
			searchView.searchParams.carat = {min: parseFloat(values[0]), max: parseFloat(values[1])}
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		},
		onInputChangeMin: window.searchView.MinCaratFieldChange,
		onInputChangeMax: window.searchView.MaxCaratFieldChange,
	})

	window.priceSlider = diamondSearchSliderCall({
		id: 'price-slider',
		title: 'Price',
		range: {
			min:window.__price.min,
			'80%': [15000, 1],
			max: window.__price.max,
		},
		start:[window.__price.min, window.__price.max],
		margin:1,
		tooltips: [
			wNumb({ thousand: ',', decimals: 0, prefix: currentCurrencySymbol }), 
			wNumb({ thousand: ',', decimals: 0, prefix: currentCurrencySymbol }),
		],
		showInput: true,
		onEnd: values => {
			searchView.searchParams.price = {min: parseFloat(values[0]), max: parseFloat(values[1])}
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		},
		onInputChangeMin: window.searchView.MinPriceFieldChange,
		onInputChangeMax: window.searchView.MaxPriceFieldChange,
	})

	window.claritySlider = diamondSearchSliderCall({
		id: 'clarity-slider',
		title: 'Clarity',
		labels: window.diamondsClarity,
		leftSublabel: 'Inclusion Visible at 10x Magnification',
		rightSublabel: 'Flawless',
		range: {
			min:0,
			max:window.diamondsClarity.length,
		},
		start:[0, window.diamondsClarity.length],
		step: 1,
		margin: 0,
		isRevert: window.revertclarity,
		onEnd: values => {
			searchView.searchParams.clarity = window.diamondsClarity.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.colorSlider = diamondSearchSliderCall({
		id: 'color-slider',
		title: 'Color',
		labels: window.diamondsColours,
		leftSublabel: 'Near Colorless',
		rightSublabel: 'Colorless',
		range: {
			min:0,
			max:diamondsColours.length,
		},
		start:[0, window.diamondsColours.length],
		step: 1,
		margin: 1,
		isRevert: window.revertcolors,
		onEnd: values => {
			searchView.searchParams.colors = window.diamondsColours.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.fancyColorIntensitySlider = diamondSearchSliderCall({
		id: 'fancy-color-intensity-slider',
		title: 'Intensity',
		labels: window.diamondsFancyColorsIntensity,
		range: {
			min:0,
			max:window.diamondsFancyColorsIntensity.length,
		},
		start:[0, window.diamondsFancyColorsIntensity.length],
		step: 1,
		margin: 1,
		onEnd: values => {
			searchView.searchParams.fancycolorintensity = window.diamondsFancyColorsIntensity.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.fluorescenceSlider = diamondSearchSliderCall({
		id: 'fluorescence-slider',
		title: 'Fluorescence',
		labels: window.diamondsFluorescence,
		range: {
			min:0,
			max:window.diamondsFluorescence.length,
		},
		start:[0, window.diamondsFluorescence.length],
		step: 1,
		margin: 1,
		onEnd: values => {
			searchView.searchParams.fluorescence = window.diamondsFluorescence.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.cutSlider = diamondSearchSliderCall({
		id: 'cut-slider',
		title: 'Cut',
		labels: window.diamondsCut,
		range: {
			min:0,
			max:diamondsCut.length,
		},
		start:[0, window.diamondsCut.length],
		step: 1,
		margin: 1,
		isRevert: revertcut,
		onEnd: values => {
			searchView.searchParams.cut = window.diamondsCut.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.polishSlider = diamondSearchSliderCall({
		id: 'polish-slider',
		title: 'Polish',
		labels: window.diamondsPolish,
		range: {
			min:0,
			max:diamondsPolish.length,
		},
		start:[0, window.diamondsPolish.length],
		step: 1,
		margin: 1,
		isRevert: revertpolish,
		onEnd: values => {
			searchView.searchParams.polish = diamondsPolish.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.symmetrySlider = diamondSearchSliderCall({
		id: 'symmetry-slider',
		isAdvanced: true,
		title: 'Symmetry',
		labels: window.diamondsSymmetry,
		range: {
			min:0,
			max:diamondsSymmetry.length,
		},
		start:[0, window.diamondsSymmetry.length],
		step: 1,
		margin: 1,
		isRevert: revertsymmetry,
		onEnd: values => {
			searchView.searchParams.symmetry = diamondsSymmetry.slice(parseInt(values[0]),parseInt(values[1])).map( i => i.value);
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.ratioSlider = diamondSearchSliderCall({
		id: 'ratio-slider',
		isAdvanced: true,
		short_field_title: true,
		title: 'Length to width ratio',
		range: {
			min:0.00,
			max:9.00,
		},
		start:[0.00, 9.99],
		tooltips: [
			wNumb({ thousand: ',', decimals: 2 }), 
			wNumb({ thousand: ',', decimals: 2 }),
		],
		showInput: true,
		onEnd: values => {
			searchView.searchParams.ratio = [parseFloat(values[0]),parseFloat(values[1])]
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.tableSlider = diamondSearchSliderCall({
		id: 'table-slider',
		isAdvanced: true,
		title: 'Table %',
		range: {
			min:0,
			max:100,
		},
		start:[0, 100],
		step: 1,
		tooltips: [
			wNumb({ thousand: ',', decimals: 0, suffix: '%' }), 
			wNumb({ thousand: ',', decimals: 0, suffix: '%' }),
		],
		showInput: true,
		onEnd: values => {
			searchView.searchParams.table = [parseFloat(values[0]),parseFloat(values[1])]
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})

	window.depthSlider = diamondSearchSliderCall({
		id: 'depth-slider',
		isAdvanced: true,
		title: 'Depth %',
		range: {
			min:0,
			max:100,
		},
		start:[0, 100],
		step: 1,
		tooltips: [
			wNumb({ thousand: ',', decimals: 0, suffix: '%' }), 
			wNumb({ thousand: ',', decimals: 0, suffix: '%' }),
		],
		showInput: true,
		onEnd: values => {
			searchView.searchParams.depth = [parseFloat(values[0]),parseFloat(values[1])]
			window.searchView.resetOffset();
			window.searchView.updateSearch(true);
		}
	})
};


document.addEventListener("DOMContentLoaded", () => {

	let searchView = new Vue({
		delimiters: ['$[', ']'],
		el:'#evosem-diamond-search',
		data: {
			dropHintMessageText: '',
			friendEmailMessageText: '',
			viewingMessageText: '',
			sendingDropHint: false,
			sendingFriendEmail: false,
			sendingScheduleRequest: false,
			popboxes: {
				drophint: false,
				moreinfo: false,
				emailfriend: false,
				scheduleview: false,
			},
			copied: false,
			pathname: window.pathname,
			visibleDialogSearchMore: false,
			visibleDialogSearch: null,
			selectedDiamond: null,
			selectedSingleDiamond: null,
			similarDiamonds: null,
			query: {
				count: 0,
				diamonds: [],
			},
			mountended:false,
			addtobagloading:false,
			ready:false,
			firstload:false,
			advancedOptionsOn: false,
			singleDiamondView: false,
			diamondsShapes: window.diamondsShapes,
			displayMode: 'list',
			selectedMediaPreview: 'image',
			selectedMediaSinglePreview: 'image',
			searchParams: {
				type: window.location.pathname.includes('natural') || window.location.search.includes('natural') ? 'natural' : 'labgrown', //natural or labgrown
				colors: window.diamondsColours.map( c => c.value),
				fancycolor: [],
				fancycolorintensity: window.diamondsFancyColorsIntensity.map( c => c.value),
				shapes: [],
				lab: [],
				orderby:'carat',
				order:'desc',
				offset:0,
				limit:20,
			},
			is_natural: 'false',
			is_fancy_initial: false,
		},
		mounted: async function() {

			await this.loadShopSettings()
	
			//Load single diamond from URL if any exists.
			this.loadSingleDiamond();

			//Fetch from the server.
			const requestToLoadAvailableValues = await fetch(`${window.__evosem_ssurl}/diamond-search/query/availablevalues`, {
				method: 'POST',
				mode: 'cors',
				cache: 'no-cache',
				credentials: 'same-origin',
				headers: {
					'X-Shopify-Shop': Shopify.shop,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					type: this.searchParams.type
				})
			}).then( res => res.json())

			if(requestToLoadAvailableValues.status) {
				const { availableValues } = requestToLoadAvailableValues;
				window.__price.min = availableValues.price.min;
				window.__price.max = availableValues.price.max;
				window.__carat.min = availableValues.carat.min;
				window.__carat.max = availableValues.carat.max;
				window.fixedLabCaratMin = availableValues.carat.min;
				window.fixedLabCaratMax = availableValues.carat.max;
			}

			if(this.searchParams.type === 'natural') {
				this.is_natural = 'true'
			}

			if( window.fixedLabCaratMin && window.fixedLabCaratMax && (this.searchParams.type === 'labgrown' || this.searchParams.type === 'natural' )) {
				window.__carat.min = window.fixedLabCaratMin
				window.__carat.max = window.fixedLabCaratMax
			}

			this.searchParams.price = {
				min: window.__price.min,
				max: window.__price.max,
			}
			this.searchParams.carat = {
				min: window.__carat.min,
				max: window.__carat.max,
			}
			this.mountended = true;

			setTimeout(() => {

				initSliders()

				//Check if the url got a pre selected shape in it.
				const urlParams = new URLSearchParams(window.location.search);
				if(urlParams.get('shape') && __shapes.map( s => s.label).includes(urlParams.get('shape'))) {
					this.searchParams.shapes = [__shapes.filter( s => s.label === urlParams.get('shape'))[0].value]
				}

				const _pathName = window.location.pathname.split('/');
				if(_pathName.includes('round-cut')) this.searchParams.shapes = ["RD"];
				if(_pathName.includes('oval-cut')) this.searchParams.shapes = ["OV"];
				if(_pathName.includes('cushion-cut')) this.searchParams.shapes = ["CU"];
				if(_pathName.includes('princess-cut')) this.searchParams.shapes = ["PR"];
				if(_pathName.includes('pear-cut')) this.searchParams.shapes = ["PS"];
				if(_pathName.includes('emerald-cut')) this.searchParams.shapes = ["EM"];
				if(_pathName.includes('marquise-cut')) this.searchParams.shapes = ["MQ"];
				if(_pathName.includes('asscher-cut')) this.searchParams.shapes = ["AS"];
				if(_pathName.includes('radiant-cut')) this.searchParams.shapes = ["RT"];
				if(_pathName.includes('heart-cut')) this.searchParams.shapes = ["HRT"];

				//Check if there is a carat weight request. the request will have one of the following numbers 1, 2, 3, 4, 5 and based on the number you have to create a range.
				//Eg: if the number is 3 create a range of 2.1 - 3 if the number is 4 create a range of 3.1 to 4
				if(urlParams.get('caratBase')) {
					const caratBase = parseInt(urlParams.get('caratBase'))
					if([1,2,3,4,5].includes(caratBase)) { //Only these numbers allowed.
							const ___min = ((caratBase - 1) + 0.1).toFixed(1),
							___max = caratBase;
							console.log(`${___min} - ${___max}`);
							window.caratSlider && (window.caratSlider.noUiSlider.updateOptions({ 
								start: [parseFloat(___min), parseFloat(___max)], 
							}))
							this.searchParams.carat = {
								min: ___min,
								max: ___max,
							}
					}
				}
				console.log("** Update search **")
				this.updateSearch(true);
			},50)
	
		},
		methods: {
			mitigateSelectors(slider, defaultValues, newValues, baseValues, isReversed = false) {
				defaultValues = baseValues.filter( i => newValues.includes(i.value) );

				if(isReversed) defaultValues.reverse()

				if(slider) {
					slider.noUiSlider.updateOptions({ start: [0,defaultValues.length], range: { min:0, max: defaultValues.length, }});
					const stepsList = slider.parentElement.querySelector('ul')
					stepsList.replaceChildren()
					defaultValues.map( item => {
						const listItem = document.createElement('li')
						listItem.innerText = item.label
						listItem.style.width = `${(100/defaultValues.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');
						listItem.classList.add('uppercase')
						listItem.appendChild(separation);
						return stepsList.appendChild(listItem);
					})
				}
			},

			async matchShopSettings(){
				const request = await fetch(`${window.__evosem_ssurl}/diamond-search/query/store`, {
					method: 'POST',
					mode: 'cors',
					cache: 'no-cache',
					credentials: 'same-origin',
					headers: {
						'X-Shopify-Shop': Shopify.shop,
						'Content-Type': 'application/json'
					},
				}).then( res => res.json())

				let { 
					natural_shapes,
					natural_colors,
					natural_clarity,
					natural_cut,
					natural_polish,
					natural_symmetry,
					natural_labs,
					natural_defaultlab,
					natural_defaultresultsorting,
					natural_defaultresultsorder,
					natural_revertclarity,
					natural_revertcolors,
					natural_revertcut,
					natural_revertpolish,
					natural_revertsymmetry,
					labgrown_shapes,
					labgrown_colors,
					labgrown_clarity,
					labgrown_cut,
					labgrown_polish,
					labgrown_symmetry,
					labgrown_labs,
					labgrown_defaultlab,
					labgrown_defaultresultsorting,
					labgrown_defaultresultsorder,
					labgrown_revertclarity,
					labgrown_revertcut,
					labgrown_revertcolors,
					labgrown_revertpolish,
					labgrown_revertsymmetry,
				} = request.shopData.ShopsMeta;


				try {
					if(this.searchParams.type === 'labgrown') {
						//If the selected type is labgrown match the saved settings with the selectors values.
						if(labgrown_colors) this.mitigateSelectors(window.colorSlider, window.diamondsColours, labgrown_colors, window.__Colours, labgrown_revertcolors === '1');
						if(labgrown_clarity) this.mitigateSelectors(window.claritySlider, window.diamondsClarity, labgrown_clarity, window.__Clarity, labgrown_revertclarity === '1');
						if(labgrown_cut)  this.mitigateSelectors(window.cutSlider, window.diamondsCut, labgrown_cut, window.__Cut, labgrown_revertcut === '1');
						if(labgrown_polish)  this.mitigateSelectors(window.polishSlider, window.diamondsPolish, labgrown_polish, window.__Polish, labgrown_revertpolish === '1');
						if(labgrown_symmetry)  this.mitigateSelectors(window.symmetrySlider, window.diamondsSymmetry, labgrown_symmetry, window.__Symmetry, labgrown_revertsymmetry === '1');
	
						//Make sure we have the right shapes in place.
						if(labgrown_shapes) {
							labgrown_shapes = JSON.parse(labgrown_shapes)
							window.diamondsShapes = window.__shapes.filter( i => labgrown_shapes.includes(i.value) );
							this.diamondsShapes = window.diamondsShapes;
						}
	
						//Update default sorting order.
						if(labgrown_defaultresultsorder && labgrown_defaultresultsorting) {
							this.searchParams.orderby = labgrown_defaultresultsorting
							this.searchParams.order = labgrown_defaultresultsorder
						}
	
					}
	
	
					if(this.searchParams.type === 'natural') {
						//If the selected type is natural match the saved settings with the selectors values.
						if(natural_colors) this.mitigateSelectors(window.colorSlider, window.diamondsColours, natural_colors, window.__Colours, natural_revertcolors === '1');
						if(natural_clarity) this.mitigateSelectors(window.claritySlider, window.diamondsClarity, natural_clarity, window.__Clarity, natural_revertclarity === '1');
						if(natural_cut)  this.mitigateSelectors(window.cutSlider, window.diamondsCut, natural_cut, window.__Cut, natural_revertcut === '1');
						if(natural_polish)  this.mitigateSelectors(window.polishSlider, window.diamondsPolish, natural_polish, window.__Polish, natural_revertpolish === '1');
						if(natural_symmetry)  this.mitigateSelectors(window.symmetrySlider, window.diamondsSymmetry, natural_symmetry, window.__Symmetry, natural_revertsymmetry === '1');
	
						//Make sure we have the right shapes in place.
						if(natural_shapes) {
							natural_shapes = JSON.parse(natural_shapes)
							window.diamondsShapes = window.__shapes.filter( i => natural_shapes.includes(i.value) );
							this.diamondsShapes = window.diamondsShapes;
						}

						//Update default sorting order.
						if(natural_defaultresultsorder && natural_defaultresultsorting) {
							this.searchParams.orderby = natural_defaultresultsorting
							this.searchParams.order = natural_defaultresultsorder
						}
					}

				} catch (error) {
					console.warn(error)
				}

				return;
			},

			async loadShopSettings(){
				
				try {

					const request = await fetch(`${window.__evosem_ssurl}/diamond-search/query/store`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
					}).then( res => res.json())

					if(request.shopData.ShopsMeta.FontSize) {
						document.documentElement.style.setProperty('--main-evosem-font-size', `${request.shopData.ShopsMeta.FontSize}px`);
					}

					let { 
						shapes, clarity, colors, cut, labs, polish, symmetry, 
						PrimaryColour, PrimaryColourLight, PrimaryColourSemiLight, PrimaryColourExtraLigh,
						revertclarity, revertcolors, 
						revertcut, revertpolish, revertsymmetry,
						labMinCarat, labMaxCarat, 
						naturalMinCarat, naturalMaxCarat,
						defaultlabgrownlab, defaultnaturallab,
						islabgrowndisabled, isnaturaldisabled, isnewtab,
						defaultresultsorting, defaultresultsorder, defaultdiamondtype,
					} = request.shopData.ShopsMeta,
					primaryColour = JSON.parse(PrimaryColour),
					primaryColourLight = JSON.parse(PrimaryColourLight),
					primaryColourSemiLight = JSON.parse(PrimaryColourSemiLight),
					primaryColourExtraLigh = JSON.parse(PrimaryColourExtraLigh);
					defaultlabgrownlab = JSON.parse(defaultlabgrownlab)
					defaultnaturallab = JSON.parse(defaultnaturallab)


					if(primaryColour) document.documentElement.style.setProperty('--main-colour', primaryColour.hex);
					if(primaryColourLight) document.documentElement.style.setProperty('--main-colour-light', primaryColourLight.hex);
					if(primaryColourSemiLight) document.documentElement.style.setProperty('--main-colour-semi-light', primaryColourSemiLight.hex);
					if(primaryColourExtraLigh) document.documentElement.style.setProperty('--main-colour-extra-light', primaryColourExtraLigh.hex);

					window.defaultlabgrownlab = !_.isEmpty(defaultlabgrownlab) ? defaultlabgrownlab : []
					window.defaultnaturallab = !_.isEmpty(defaultnaturallab) ? defaultnaturallab : []

					window.islabgrowndisabled = islabgrowndisabled === '1' ? true : false
					window.isnaturaldisabled = isnaturaldisabled === '1' ? true : false
					window.isnewtab = isnewtab === '1' ? true : false

					shapes = JSON.parse(shapes);
					colors = JSON.parse(colors);
					clarity = JSON.parse(clarity);
					cut = JSON.parse(cut);
					polish = JSON.parse(polish);
					symmetry = JSON.parse(symmetry);
					labs = JSON.parse(labs);

					window.diamondsShapes = this.diamondsShapes = window.diamondsShapes.filter( i => shapes.includes(i.value) );
					window.diamondsColours = window.diamondsColours.filter( i => colors.includes(i.value) );
					window.diamondsClarity = window.diamondsClarity.filter( i => clarity.includes(i.value) );
					window.diamondsLabs = window.diamondsLabs.filter( i => labs.includes(i) );
					window.diamondsCut = window.diamondsCut.filter( i => cut.includes(i.value) );
					window.diamondsPolish = window.diamondsPolish.filter( i => polish.includes(i.value) );
					window.diamondsSymmetry = window.diamondsSymmetry.filter( i => symmetry.includes(i.value) );
					window.revertcolors = revertcolors === '1' ? true : false;
					window.revertclarity = revertclarity === '1' ? true : false;
					window.revertcut = revertcut === '1' ? true : false;
					window.revertpolish = revertpolish === '1' ? true : false;
					window.revertsymmetry = revertsymmetry === '1' ? true : false;

					if(window.revertcolors) window.diamondsColours.reverse();
					if(window.revertclarity) window.diamondsClarity.reverse();
					if(window.revertcut) window.diamondsCut.reverse();
					if(window.revertpolish) window.diamondsPolish.reverse();
					if(window.revertsymmetry) window.diamondsSymmetry.reverse();

					if(labMinCarat && labMaxCarat && labMinCarat !== '0' && labMaxCarat !== '0') {
						window.fixedLabCaratMin = !isNaN(parseFloat(labMinCarat)) ? parseFloat(labMinCarat) : null
						window.fixedLabCaratMax = !isNaN(parseFloat(labMaxCarat)) ? parseFloat(labMaxCarat) : null
					}

					if(naturalMinCarat && naturalMaxCarat && naturalMinCarat !== '0' && naturalMaxCarat !== '0') {
						window.fixedNaturalCaratMin = !isNaN(parseFloat(naturalMinCarat)) ? parseFloat(naturalMinCarat) : null
						window.fixedNaturalCaratMax = !isNaN(parseFloat(naturalMaxCarat)) ? parseFloat(naturalMaxCarat) : null
					}

					this.searchParams.colors = window.diamondsColours.map( c => c.value )
					this.searchParams.fancycolorintensity = window.diamondsFancyColorsIntensity.map( c => c.value )
					this.searchParams.clarity = window.diamondsClarity.map( c => c.value )
					this.searchParams.clarity = window.diamondsClarity.map( c => c.value )

					if( !_.isEmpty(window.defaultlabgrownlab) && this.searchParams.type === 'labgrown') this.searchParams.lab = window.defaultlabgrownlab.filter( l => l !== 'none')
					if( !_.isEmpty(window.defaultnaturallab) && this.searchParams.type === 'natural') this.searchParams.lab = window.defaultnaturallab.filter( l => l !== 'none')


					if( window.islabgrowndisabled && this.searchParams.type === 'labgrown') this.searchParams.type = 'natural' 
					if( window.isnaturaldisabled && this.searchParams.type === 'natural') this.searchParams.type = 'labgrown' 

					if(!_.isEmpty(defaultresultsorting)) {
						this.searchParams.orderby = defaultresultsorting
					}

					if(!_.isEmpty(defaultresultsorder)) {
						this.searchParams.order = defaultresultsorder
					}

					if(!_.isEmpty(defaultdiamondtype) && !(window.location.pathname.includes('natural') || window.location.search.includes('natural') || window.location.pathname.includes('labgrown') || window.location.search.includes('labgrown'))) {
						this.searchParams.type = defaultdiamondtype
					}

					return;

				} catch ( error ) {
					console.log(error)
					return;
				}






































			},
			addToRing(item, redirect = true) {
				let shop_ring_settings = localStorage.getItem(MainRingBuilderStorageKey);
				const {color, carat, sku, cut, clarity} = item
				const customUrl = `${carat}-carat-${cut}-cut-${color}-color-${clarity}-clarity-diamond-stock-${sku}`.toLocaleLowerCase().replaceAll('.','-')
				item.customUrl = customUrl;
				shop_ring_settings = _.isEmpty(shop_ring_settings) ? {} : JSON.parse(shop_ring_settings),
				shop_ring_settings.diamond = item

				localStorage.setItem(MainRingBuilderStorageKey, JSON.stringify(shop_ring_settings))
				
				if(redirect) {
					if(shop_ring_settings?.ring?.variant) {
						window.location.replace('/pages/ringbuilder')
					} else {
						window.location.replace('/collections/build-an-engagement-ring')
					}
				}
				return document.dispatchEvent(new Event("ringbuilderstoragechange"))
				
			},
			async switchToNatural() {

				this.searchParams.type = 'natural'
				this.searchParams.fancycolor = []
				this.is_natural = 'true'
				await this.loadAvailableValues();
				await this.matchShopSettings();
				console.log('------------Natural Switch---------------')
				return this.updateSearch(true)
			},
			async switchToFancy() {

				this.searchParams.type = 'labgrown'
				this.searchParams.fancycolor = window.diamondsFancyColors.map(v => v.value)
				this.is_natural = 'fancycolor'
				this.is_fancy_initial = true;
				console.log('------------Fancylab Switch---------------')
				await this.loadAvailableValues();
				await this.matchShopSettings();
				

				return this.updateSearch(true)
			},
			async switchToLab() {

				this.searchParams.type = 'labgrown'
				this.searchParams.fancycolor = []
				this.is_natural = 'false'
				await this.loadAvailableValues();
				await this.matchShopSettings();
				console.log('------------Labgrown Switch---------------')
				return this.updateSearch(true)
			},
			async switchDiamondLoadedType() {

				this.searchParams.type = this.searchParams.type === 'labgrown' ? 'natural' : 'labgrown'

				if( window.fixedLabCaratMin && window.fixedLabCaratMax && this.searchParams.type === 'labgrown') {
					window.__carat.min = window.fixedLabCaratMin
					window.__carat.max = window.fixedLabCaratMax
					caratSlider.noUiSlider.updateOptions({ range: {min: parseFloat(window.__carat.min), max: parseFloat(window.__carat.max)} });	
					caratSlider.noUiSlider.updateOptions({ start: [parseFloat(window.__carat.min), parseFloat(window.__carat.max)] });
					if(this.searchParams?.carat?.min) this.searchParams.carat.min = window.__carat.min
					if(this.searchParams?.carat?.max) this.searchParams.carat.max = window.__carat.max
				}

				if( window.fixedLabCaratMin && window.fixedLabCaratMax && this.searchParams.type === 'natural') {
					window.__carat.min = window.fixedNaturalCaratMin
					window.__carat.max = window.fixedNaturalCaratMax
					caratSlider.noUiSlider.updateOptions({ range: {min: parseFloat(window.__carat.min), max: parseFloat(window.__carat.max)} });	
					caratSlider.noUiSlider.updateOptions({ start: [parseFloat(window.__carat.min), parseFloat(window.__carat.max)] });
					if(this.searchParams?.carat?.min) this.searchParams.carat.min = window.__carat.min
					if(this.searchParams?.carat?.max) this.searchParams.carat.max = window.__carat.max
				}

				if( !_.isEmpty(window.defaultlabgrownlab) && this.searchParams.type === 'labgrown') {
					this.searchParams.lab = window.defaultlabgrownlab.filter( l => l !== 'none')
				}

				if( !_.isEmpty(window.defaultnaturallab) && this.searchParams.type === 'natural') {
					this.searchParams.lab = window.defaultnaturallab.filter( l => l !== 'none')
				}

				console.log(`------------${this.searchParams.type} Switch---------------`)

				//make sure the filters are matching the provided settings
				await this.matchShopSettings();


				this.updateSearch(true);
			},
			getFancyColorName(_value) {
				const item = diamondsFancyColors.filter( i => i.value === _value);
				if(!_.isEmpty(item)) return item[0].label;

				return _value;

			},
			getFancyColorIntensityName(_value) {
				const item = diamondsFancyColorsIntensity.filter( i => i.value === _value);
				if(!_.isEmpty(item)) return item[0].label;

				return _value;

			},
			getCutName(_value) {
				const item = diamondsCut.filter( i => i.value === _value);
				if(!_.isEmpty(item)) return item[0].label;

				return _value;

			},
			getPolishName(_value) {
				const item = diamondsPolish.filter( i => i.value === _value);
				if(!_.isEmpty(item)) return item[0].label;
				return _value;
			},
			getFluorescenceIntensityName(_value) {
				const item = diamondsFluorescence.filter( i => i.value === _value);
				console.log(item)
				if(!_.isEmpty(item)) return item[0].label;
				return 'N/A';
			},
			getSymmetryName(_value) {
				const item = diamondsSymmetry.filter( i => i.value === _value);
				if(!_.isEmpty(item)) return item[0].label;

				return _value;

			},
			updateLabCerts(item) {
				if(typeof this.searchParams.lab === 'undefined') this.searchParams.lab = [];
				if(this.searchParams.lab.includes(item)){
					this.searchParams.lab = this.searchParams.lab.filter(c => c !== item);
				} else {
					this.searchParams.lab = [...this.searchParams.lab,item];
				}
				this.resetOffset();
				this.updateSearch(true);
			},
			skuSearchInput(){
				this.resetOffset();
				this.updateSearch(true);
			},
			closeDiamondSingleView() {
				window.history.pushState(false,false, `${this.pathname}`);
				this.singleDiamondView = false;
				this.selectedSingleDiamond = null;
				this.selectedMediaSinglePreview = 'image';
				this.similarDiamonds = null;
			},
			openDiamondSingleView(item, pushToHistory = true, isDirect = false) {

				//Make sure the videos and pictures are removed.
				item.pictures = []

				if(item) this.selectedSingleDiamond = item

				//Run media check no need to wait for it.
				fetch('https://api.mydiamonds.io/query/diamond/media', {
					headers: {
						"content-type": "application/json",
					},
					method: "POST",
					body: JSON.stringify({
						sku: item.sku
					})
				}).then( res => res.json())
				.then( res => {
					delete res.status
					const __videos = item.videos;
					item = {...item, ...res}
					this.selectedSingleDiamond = {...this.selectedSingleDiamond, ...res}

					if(_.isEmpty(this.selectedSingleDiamond.videos)) {
						this.selectedSingleDiamond.videos = __videos
					}
				})

				try {
					let { carat, cut, color, clarity, sku } = this.selectedSingleDiamond;

					if(!_.isEmpty(window.diamondsCut.filter( c => c.value === cut ))) {
						cut = _.head(window.diamondsCut.filter( c => c.value === cut )).value;
					}

					const customUrl = `${carat}-carat-${cut}-cut-${color}-color-${clarity}-clarity-diamond-stock-${sku}`.toLocaleLowerCase().replaceAll('.','-');

					if(window.isnewtab && !isDirect) {
						return window.open(`${this.pathname}/${customUrl}`, '_blank');
					}

					window.scrollTo({ top: 0});
					this.singleDiamondView = true;
					this.selectedMediaPreview = 'image';
					this.similarDiamonds = null;
					this.loadSimilarDiamonds();


					if(pushToHistory) window.history.pushState({},'', `${this.pathname}/${customUrl}`);

				} catch ( error ) {
					console.warn(error)
				}

			},
			addToBag(item) {

				let diamond = item;
				if(!diamond) diamond = this.selectedDiamond;
				if(!diamond.sku || diamond.price <= 0) return;
				this.addtobagloading = true

				const request = fetch(`${window.__evosem_ssurl}/diamond-search/query/addtobag`, {
					method: 'POST',
					mode: 'cors',
					cache: 'no-cache',
					credentials: 'same-origin',
					headers: {
						'X-Shopify-Shop': Shopify.shop,
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						diamond: diamond.sku,
					})
				}).then( res => res.json())
				.then( res => {
					this.addtobagloading = false;
					if(res.status) {
						fetch(window.Shopify.routes.root + 'cart/add.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								'items': [{
									'id': res.product.variants[0].id,
									'quantity': 1
								}]
							})
						}).then( res => res.json())
						.then( res => {
							window.location.href = `https://${window.Shopify.shop}/cart`;
						}).catch( error => {
							//Dialog info box.
							console.warn(error);
						})
					}
				}).catch( error => {
					//Dialog info box.
					console.warn(error);
				});
			},
			async loadAvailableValues(){
				this.ready = false;
				let e = await fetch(`${window.__evosem_ssurl}/diamond-search/query/availablevalues`, {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"X-Shopify-Shop": Shopify.shop,
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						type: this.searchParams.type,
					})
				}).then(e => e.json());
				if (e.status) {
					let {
						availableValues: a
					} = e;
					window.__price.min = a.price.min, 
					window.__price.max = a.price.max, 
					window.__carat.min = a.carat.min, 
					window.__carat.max = a.carat.max;

					window.priceSlider && (window.priceSlider.noUiSlider.updateOptions({ 
						range: {
							min: parseFloat(window.__price.min),
							max: parseFloat(window.__price.max),
						},
						start: [parseFloat(window.__price.min), parseFloat(window.__price.max)], 
					})),
					window.caratSlider && (window.caratSlider.noUiSlider.updateOptions({ 
						range: {
							min: parseFloat(window.__carat.min),
							max: parseFloat(window.__carat.max),
						},
						start: [parseFloat(window.__carat.min), parseFloat(window.__carat.max)], 
					}))

					//Update other selectors such as colour clarity polish and symmetry....


				}

				return this.ready = true;;

			},
			loadSingleDiamond() {
				try {

					const _pathName  = window.location.pathname.split('-');
					const _pathNameIndex = _.findIndex(window.location.pathname.split('-'), (i) => i === 'stock');
					if(_pathNameIndex && (_pathNameIndex !== -1)) {
						const __stockNumber = _pathName.slice((_pathNameIndex + 1),_pathName.length).join('-');
						//Fetch from the server.
						const request = fetch(`${window.__evosem_ssurl}/diamond-search/query`, {
							method: 'POST',
							mode: 'cors',
							cache: 'no-cache',
							credentials: 'same-origin',
							headers: { 
								'X-Shopify-Shop': Shopify.shop,
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								skusearch: __stockNumber
							})
						}).then( res => res.json())
						.then( data => {

							let { diamonds, count, status } = data;

							if(status) {
								diamonds = diamonds.map( d => {

									const shape = __shapes.filter( s => s.value === d.shape);
									const polish = __shapes.filter( s => s.value === d.polish);
									const symmetry = __shapes.filter( s => s.value === d.symmetry);
									const cut = __shapes.filter( s => s.value === d.cut);

									if(!_.isUndefined(shape[0]) && !_.isUndefined(shape[0].label)) d.shape = shape[0].label;
									if(!_.isUndefined(polish[0]) && !_.isUndefined(polish[0].label)) d.polish = polish[0].label;
									if(!_.isUndefined(symmetry[0]) && !_.isUndefined(symmetry[0].label)) d.symmetry = symmetry[0].label;
									if(!_.isUndefined(cut[0]) && !_.isUndefined(cut[0].label)) d.cut = cut[0].label;

									return d;
								});

								if(!_.isEmpty(_.head(diamonds))) {
									this.openDiamondSingleView(_.head(diamonds), false, true);
								}

							}

						}).catch( error => {
							console.warn(error);
						})
					}

				} catch (error) {
					console.warn(error)
				}
			},
			updateShape(item) {
				if(this.searchParams.shapes.includes(item)) {
					this.searchParams.shapes = this.searchParams.shapes.filter( s => s !== item)
				} else {
					this.searchParams.shapes.push(item)
				}
				// this.searchParams.shapes = !this.searchParams.shapes.includes(item) ? [item] : [];
				this.updateSearch(true);
			},
			updateFancycolor(fancycolor) {
				if(_.isEmpty(this.searchParams.fancycolor)) this.searchParams.fancycolor = [] 
				if(this.is_fancy_initial) this.searchParams.fancycolor = []
				this.is_fancy_initial = false
				if(this.searchParams.fancycolor.includes(fancycolor)) {
					this.searchParams.fancycolor = this.searchParams.fancycolor.filter( s => s !== fancycolor);
				} else {
					this.searchParams.fancycolor = [...this.searchParams.fancycolor, fancycolor];
				}
				this.updateSearch(true);

			},
			resetOffset(){
				this.searchParams.offset = 0;
			},
			switchOrder(item){
				if(item === this.searchParams.orderby) this.searchParams.order = this.searchParams.order === 'desc' ? 'asc' : 'desc';
				this.searchParams.orderby = item;
				this.resetOffset();
				return this.updateSearch(true);
			},
			selectDiamond(item) {

				if(_.isEmpty(item.pictures)) {
					item.pictures = [`https://api.mydiamonds.io/media/sample-${item.shape}.jpg`]
				}

				return this.selectedDiamond = item;
			},
			updateSearch:_.debounce(function(resetList = false){

				try {

					this.ready = false;

					if(resetList) {
						this.searchParams.offset = 0
					}

					const parameters = this.searchParams;
					parameters.selectedShape = this.searchParams.shapes


					//Fetch from the server.
					const request = fetch(`${window.__evosem_ssurl}/diamond-search/query`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: { 
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(parameters)
					}).then( res => res.json())
					.then( data => {

						let { status, diamonds, count } = data;

						if(!status) {

							this.query.diamonds = [];
							this.query.count = 0;
							this.firstload = true;
							this.ready = true;
							this.selectedDiamond = null;
							return;

						}

						if(status) {

							diamonds = diamonds.map( d => {

								const shape = __shapes.filter( s => s.value === d.shape);
								const polish = __shapes.filter( s => s.value === d.polish);
								const symmetry = __shapes.filter( s => s.value === d.symmetry);
								const cut = __shapes.filter( s => s.value === d.cut);

								if(!_.isUndefined(shape[0]) && !_.isUndefined(shape[0].label)) d.shape = shape[0].label;
								if(!_.isUndefined(polish[0]) && !_.isUndefined(polish[0].label)) d.polish = polish[0].label;
								if(!_.isUndefined(symmetry[0]) && !_.isUndefined(symmetry[0].label)) d.symmetry = symmetry[0].label;
								if(!_.isUndefined(cut[0]) && !_.isUndefined(cut[0].label)) d.cut = cut[0].label;

								return d;
							})

							if(resetList) {
								this.query.diamonds = diamonds;
							} else {
								this.query.diamonds = [...this.query.diamonds,...diamonds];
							}

							this.query.count = '...';
							this.firstload = true;
							this.ready = true;
							this.selectedDiamond = null;
							if(!_.isUndefined(this.query.diamonds) && this.query.diamonds.length) this.selectDiamond(this.query.diamonds[0]);

							fetch(`${window.__evosem_ssurl}/diamond-search/query/count`, {
								method: "POST",
								mode: "cors",
								cache: "no-cache",
								credentials: "same-origin",
								headers: {
									"X-Shopify-Shop": Shopify.shop,
									"Content-Type": "application/json"
								},
								body: JSON.stringify(parameters)
							}).then(response => response.json()).then(response => {
								if(response.status) {
									this.query.count = response.count
								}
							})
						}

					})
					.catch( err => {
						console.warn(err);
						this.ready = true;
					});

				} catch (error) {
					console.warn(error);
				}
			},400),
			loadMoreDiamonds() {
				this.searchParams.offset = this.searchParams.offset + 1;
				this.updateSearch(false);
			},
			resetSearch() {

				this.searchParams.selectedShape = [];

				if(priceSlider) priceSlider.noUiSlider.updateOptions({ start: [window.__price.min, window.__price.max] });	
				if(caratSlider) caratSlider.noUiSlider.updateOptions({ start: [window.__carat.min, window.__carat.max], });	
				if(ratioSlider) ratioSlider.noUiSlider.updateOptions({ start: [0.00, 9.99] });	
				if(tableSlider) tableSlider.noUiSlider.updateOptions({ start: [parseFloat(0),parseFloat(100)] });	
				if(depthSlider) depthSlider.noUiSlider.updateOptions({ start: [parseFloat(0),parseFloat(100)] });	
				if(colorSlider) colorSlider.noUiSlider.updateOptions({ start: [0,diamondsColours.length]});
				if(fluorescenceSlider) fluorescenceSlider.noUiSlider.updateOptions({ start: [0,diamondsFluorescence.length]});
				if(claritySlider) claritySlider.noUiSlider.updateOptions({ start: [0,diamondsClarity.length]});
				if(cutSlider) cutSlider.noUiSlider.updateOptions({ start: [0,diamondsCut.length]});
				if(polishSlider) polishSlider.noUiSlider.updateOptions({ start: [0,diamondsPolish.length]});
				if(symmetrySlider) symmetrySlider.noUiSlider.updateOptions({ start: [0,diamondsSymmetry.length]});

				this.searchParams.price = {
					min: window.__price.min,
					max: window.__price.max,
				}
				this.searchParams.carat = {
					min: window.__carat.min,
					max: window.__carat.max,
				}

				this.searchParams.ratio = [[0.00, 9.99]]
				this.searchParams.table = [parseFloat(0),parseFloat(100)]
				this.searchParams.depth = [parseFloat(0),parseFloat(100)]

				this.searchParams.colors = window.diamondsColours.map( c => c.value )
				this.searchParams.fancycolorintensity = window.diamondsFancyColorsIntensity.map( c => c.value )
				this.searchParams.clarity = window.diamondsClarity.map( c => c.value )
				this.searchParams.shapes =  [];
				this.searchParams.offset = 0;
				this.searchParams.limit = 20;
				if( !_.isEmpty(window.defaultlabgrownlab) && this.searchParams.type === 'labgrown') this.searchParams.lab = window.defaultlabgrownlab.filter( l => l !== 'none')
				if( !_.isEmpty(window.defaultnaturallab) && this.searchParams.type === 'natural') this.searchParams.lab = window.defaultnaturallab.filter( l => l !== 'none')

				this.updateSearch(true);
			},
			printDiamond() {
				var prtContent = document.getElementById("_evosem-print-version");
				var WinPrint = window.open('', '', 'toolbar=0,scrollbars=0,status=0');
				WinPrint.document.write(prtContent.innerHTML);
				WinPrint.document.close();
				WinPrint.focus();
				WinPrint.print();					
			},
			loadSimilarDiamonds() {
				let { shape, cut, polish, symmetry, type, carat } = this.selectedSingleDiamond;
				const ___shape = window.__shapes.filter( i => i.label === shape);

				if(!_.isEmpty(___shape)) {
					shape = ___shape[0].value;
				} else {
					shape = 'all';
				}

				const request = fetch(`${window.__evosem_ssurl}/diamond-search/query`, {
					method: 'POST',
					mode: 'cors',
					cache: 'no-cache',
					credentials: 'same-origin',
					headers: { 
						'X-Shopify-Shop': Shopify.shop,
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						type: type,
						selectedShape: [shape],
						cut: [cut],
						polish: [polish],
						symmetry: [symmetry],
						carat: {
							min: carat - 0.1,
							max: carat + 0.1,
						}
					})
				}).then( res => res.json())
				.then( async data => {
					if(!_.isEmpty(data.diamonds)) {

						data.diamonds = data.diamonds.filter( d => d.sku !== this.selectedSingleDiamond.sku);

						if(_.isEmpty(data.diamonds)) return;

						data.diamonds = data.diamonds.map( d => {

							const shape = __shapes.filter( s => s.value === d.shape);
							const polish = __shapes.filter( s => s.value === d.polish);
							const symmetry = __shapes.filter( s => s.value === d.symmetry);
							const cut = __shapes.filter( s => s.value === d.cut);

							if(!_.isUndefined(shape[0]) && !_.isUndefined(shape[0].label)) d.shape = shape[0].label;
							if(!_.isUndefined(polish[0]) && !_.isUndefined(polish[0].label)) d.polish = polish[0].label;
							if(!_.isUndefined(symmetry[0]) && !_.isUndefined(symmetry[0].label)) d.symmetry = symmetry[0].label;
							if(!_.isUndefined(cut[0]) && !_.isUndefined(cut[0].label)) d.cut = cut[0].label;

							return d;
						})

						this.similarDiamonds = _.shuffle(data.diamonds).slice(0,4);

						for (let index = 0; index < this.similarDiamonds.length; index++) {
							const item = this.similarDiamonds[index];
							item.pictures = []
							//Run media check no need to wait for it.
							const response = await fetch('https://api.mydiamonds.io/query/diamond/media', {
								headers: {
									"content-type": "application/json",
								},
								method: "POST",
								body: JSON.stringify({
									sku: item.sku
								})
							}).then( res => res.json())

							delete response.status
							item.pictures = response.pictures
							item.isPlaceholder = response.isPlaceholder
						}
					}
				}).catch( error => {
					console.warn(error);
				});
			},
			closeDropBox(item) {
				this.popboxes[item] = false;
				this.dropHintMessageText = '';
			},
			openDropBox(item) {
				this.popboxes[item] = true
				setTimeout(() => window.scrollTo({ top: 0}) , 300)
			},
			submitRequestMoreInfo: async function($event) {
				$event.preventDefault();
				const { friendEmail1, friendEmail2, friendEmailMessage } = this.$refs;
				let errors = [];
			},
			switchMediaSinglePreview(mode) {
				this.selectedMediaSinglePreview = mode;
			},
			MinPriceFieldChange: _.debounce(function($event){
				try {
					const value = parseFloat($event.target.value.replace(/[$,]/g, ''))
					this.searchParams.price.min  = value
					priceSlider.noUiSlider.updateOptions({ start: [parseFloat(this.searchParams.price.min),parseFloat(this.searchParams.price.max)] });	
					this.updateSearch(true)
				} catch (error) {
					console.log(error)
				}
			},2000),
			MaxPriceFieldChange: _.debounce(function($event){
				try {
					const value = parseFloat($event.target.value.replace(/[$,]/g, ''))
					this.searchParams.price.max  = value
					priceSlider.noUiSlider.updateOptions({ start: [parseFloat(this.searchParams.price.min),parseFloat(this.searchParams.price.max)] });	
					this.updateSearch(true)
				} catch (error) {
					console.log(error)
				}
			},2000),
			MinCaratFieldChange: _.debounce(function($event){
				try {
					const value = parseFloat($event.target.value.replace(/[^0-9.]/g, ''))
					this.searchParams.carat.min  = value
					caratSlider.noUiSlider.updateOptions({ start: [parseFloat(this.searchParams.carat.min),parseFloat(this.searchParams.carat.max)] });	
					this.updateSearch(true)
				} catch (error) {
					console.log(error)
				}
			},2000),
			MaxCaratFieldChange: _.debounce(function($event){
				try {
					const value = parseFloat($event.target.value.replace(/[^0-9.]/g, ''))
					this.searchParams.carat.max  = value
					caratSlider.noUiSlider.updateOptions({ start: [parseFloat(this.searchParams.carat.min),parseFloat(this.searchParams.carat.max)] });	
					this.updateSearch(true)
				} catch (error) {
					console.log(error)
				}
			},2000),
		},
	});

	window.searchView = searchView
})